import React, { Fragment,useEffect, useState } from 'react';
import { connect } from 'react-redux';
import dynamic from 'next/dynamic';

import ZpButton from 'components/zpButton';
import { formatNumber, formatSubPageText, importStatic } from 'utils';
import { CLUSTER_HEADER_CATEGORY,CPP_SUBPAGES } from 'utils/constant';

import { toggleUserFavouriteCompany } from '../../../services/userService';
import {
  updateCompanyIsSaved,
  updateUserFavouriteCompanies,
} from '../../../store/companyPage/actions';
import { openLoginModal, updateAddCompanyToFavouriteInQueue } from '../../../store/modals/actions';
import SearchBar from '../common/SearchBar';
import SubHeader from '../common/SubHeader';

import CompanyClusterHeaderTitle from './CompanyClusterHeaderTitle';

const PendingChanges = dynamic(() => import('./PendingChangesHeader'));

const getTitle = (company, page, subTitle, data) => {
  const titles = {
    [CPP_SUBPAGES.OVERVIEW]: `Working At ${company}`,
    [CPP_SUBPAGES.SALARY]: `${company} Salaries`,
    [CPP_SUBPAGES.DEMOGRAPHICS]: `${company} Statistics And Demographics`,
    [CPP_SUBPAGES.JOBS]: `${company} Jobs`,
    [CPP_SUBPAGES.HISTORY]: `${company} History`,
    [CPP_SUBPAGES.REVIEWS]: `${company} Reviews`,
    [CPP_SUBPAGES.LOCATIONS]: `${company} Locations`,
    [CPP_SUBPAGES.EXECUTIVES]: `${company} ${subTitle}`,
    [CPP_SUBPAGES.REVENUE]: `${company} Revenue`,
    [CPP_SUBPAGES.JOB_TITLE_COMBO_JOBS]: data?.metadata?.H1,
    [CPP_SUBPAGES.LOCATION_COMBO_JOBS]: `${company} ${data?.criteria?.city}, ${data?.criteria?.stateAbbr} Jobs`,
    [CPP_SUBPAGES.JOB_TITLE_SALARY]: `${company} ${data?.criteria?.title} Salary`,
    [CPP_SUBPAGES.STATE_SALARY]: `Average ${company} Salary in ${data.criteria?.state}`,
    [CPP_SUBPAGES.CITY_SALARY]: `Average ${company} Salary in ${data.criteria?.city}, ${data.criteria?.stateAbbr}`,
    [CPP_SUBPAGES.FAQ]: data?.metadata?.H1,
  };

  return titles[page] || `${company} ${subTitle}`;
};

const CompanyClusterHeader = ({
  subPageName,
  subTitle,
  updateUserFavouriteCompanies,
  updateCompanyIsSaved,
  updateAddCompanyToFavouriteInQueue,
  openLoginModal,
  favouriteCompanies,
  companyIsSaved,
  user,
  dynamicPage,
  ...data
}) => {
  const {
    breadCrumbs,
    claimedCompany,
    pendingChanges,
    companyInfo,
    userFavouriteCompanies: userFavouriteCompaniesInit = [],
  } = data;
  const { companyName, companyNameCPS } = companyInfo;
  const isUserLoggedIn = !!(user && user.isLoggedIn);

  const [isFavouriteLoading, setFavouriteLoading] = useState(false);

  useEffect(() => {
    updateUserFavouriteCompanies(userFavouriteCompaniesInit);
    const companyIsSavedInit = userFavouriteCompaniesInit.some(
      (item) => item.companyID === companyInfo.companyID
    );
    updateCompanyIsSaved(companyIsSavedInit);
  }, []);

  const toggleSaveCompany = () => {
    if (isUserLoggedIn) {
      setFavouriteLoading(true);
      updateCompanyIsSaved(!companyIsSaved);
      toggleUserFavouriteCompany(companyInfo, favouriteCompanies)
        .then((companies) => {
          updateUserFavouriteCompanies(companies);
        })
        .finally(() => {
          setFavouriteLoading(false);
        });
    } else {
      updateAddCompanyToFavouriteInQueue({
        companyName: companyInfo.companyNameCPS,
        companyNameCPS: companyInfo.companyNameCPS,
        companyID: companyInfo.companyID,
        key: companyInfo.companyName,
        selected: true,
      });
      openLoginModal({
        isAddCompanyToFavouriteModal: true,
      });
    }
  };

  const getCalloutButtonContent = () => {
    let text = 'Follow Company';
    if (companyIsSaved) {
      text = 'Unfollow Company';
    }
    return <span>{text}</span>;
  };

  const getCalloutButtonIcon = () => (
    <div
      className={`z-font-18 ${
        companyIsSaved ? 'icon-icon-notification-off' : 'icon-icon-notification'
      }`}
    />
  );

  const getCallout = () => {
    const calloutButtonIcon = getCalloutButtonIcon();
    const calloutButtonContent = getCalloutButtonContent();

    return (
      <div className="header-callout">
        <ZpButton
          theme="super-primary"
          icon={calloutButtonIcon}
          className={`header-callout-button show-icon-desktop border-mobile company-page-follow-btn ${
            companyIsSaved ? 'inverse' : ''
          }`}
          onClick={toggleSaveCompany}
          disabled={isFavouriteLoading}
          type="button"
        >
          {calloutButtonContent}
        </ZpButton>
      </div>
    );
  };

  return (
    <Fragment>
      <div className="company-search py-0">
        {claimedCompany && pendingChanges && <PendingChanges />}
        <div className="container">
          <div className="company-search-row flex-column-reverse flex-lg-row align-items-start ">
            <CompanyClusterHeaderTitle
              subPageName={subPageName}
              subTitle={subTitle}
              title={getTitle(
                companyNameCPS || companyName,
                subPageName,
                subTitle || formatSubPageText(subPageName, CLUSTER_HEADER_CATEGORY.COMPANY),
                data
              )}
              data={data}
              dynamicPage={dynamicPage}
            />

            <SearchBar
              dynamicPage={dynamicPage}
              subPageName={subPageName}
              clusterCategory={CLUSTER_HEADER_CATEGORY.COMPANY}
              className="z-mt-12 z-mt-md-44 mb-0"
              criteria={data.criteria}
            />
          </div>
        </div>
      </div>
      <div className="sub-header-container">
        <SubHeader callout={getCallout()} {...data} />
      </div>
      {/*mobile callout*/}
      {getCallout()}
    </Fragment>
  );
};

const mapStateToProps = ({ jobs, user, companyPage }) => ({
  userListingHashes: jobs,
  user,
  companyIsSaved: companyPage.companyIsSaved,
  favouriteCompanies: companyPage.userFavouriteCompanies,
});

const mapDispatchToProps = {
  openLoginModal,
  updateUserFavouriteCompanies,
  updateCompanyIsSaved,
  updateAddCompanyToFavouriteInQueue,
};

export default connect(mapStateToProps, mapDispatchToProps)(CompanyClusterHeader);
